import ThiSensors from "./thi-sensors.vue";

export default ThiSensors;



// WEBPACK FOOTER //
// ./src/components/_thi-sensors/index.js